// Üye ol aksiyonları
export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';



// Üye giriş aksiyonları
export const SIGN_IN_REQUEST = 'SIGN_IN_REQUEST';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE';
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';


// MasterPage Drawer
export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';

// Üye profili aksiyonları
export const PROFILE_REQUEST = 'PROFILE_REQUEST';
export const PROFILE_SUCCESS = 'PROFILE_SUCCESS';
export const PROFILE_FAILURE = 'PROFILE_FAILURE';

// Üye profili güncelleme aksiyonları
export const PROFILEUPDATE_REQUEST = 'PROFILEUPDATE_REQUEST';
export const PROFILEUPDATE_SUCCESS = 'PROFILEUPDATE_SUCCESS';
export const PROFILEUPDATE_FAILURE = 'PROFILEUPDATE_FAILURE';



// Sipariş aksiyonları
export const ORDERS_FETCH_REQUEST = 'ORDERS_FETCH_REQUEST';
export const ORDERS_FETCH_SUCCESS = 'ORDERS_FETCH_SUCCESS';
export const ORDERS_FETCH_FAILURE = 'ORDERS_FETCH_FAILURE';


export const PROFILE_UPDATE_REQUEST = 'PROFILEUPDATE_REQUEST';
export const PROFILE_UPDATE_SUCCESS = 'PROFILEUPDATE_SUCCESS';
export const PROFILE_UPDATE_FAILURE = 'PROFILEUPDATE_FAILURE';


// Üye ADDRESS  aksiyonları
export const ADDRESS_REQUEST = 'ADDRESS_REQUEST';
export const ADDRESS_SUCCESS = 'ADDRESS_SUCCESS';
export const ADDRESS_FAILURE = 'ADDRESS_FAILURE';

// Üye ADDRESS UPDATE aksiyonları
export const ADDRESS_UPDATE_REQUEST = 'ADDRESS_UPDATE_REQUEST';
export const ADDRESS_UPDATE_SUCCESS = 'ADDRESS_UPDATE_SUCCESS';
export const ADDRESS_UPDATE_FAILURE = 'ADDRESS_UPDATE_FAILURE';

// Üye ADDRESS add aksiyonları
export const ADDRESS_ADD_REQUEST = 'ADDRESS_ADD_REQUEST';
export const ADDRESS_ADD_SUCCESS = 'ADDRESS_ADD_SUCCESS';
export const ADDRESS_ADD_FAILURE = 'ADDRESS_ADD_FAILURE';

// order aksiyonları
export const ORDER_REQUEST = 'ORDER_REQUEST';
export const ORDER_SUCCESS = 'ORDER_SUCCESS';
export const ORDER_FAILURE = 'ORDER_FAILURE';



// mağza ekleme aksiyonları
export const COMPANY_ADD_REQUEST = 'COMPANY_ADD_REQUEST';
export const COMPANY_ADD_SUCCESS = 'COMPANY_ADD_SUCCESS';
export const COMPANY_ADD_FAILURE = 'COMPANY_ADD_FAILURE';


// mağza get aksiyonları
export const COMPANY_GET_REQUEST = 'COMPANY_GET_REQUEST';
export const COMPANY_GET_SUCCESS = 'COMPANY_GET_SUCCESS';
export const COMPANY_GET_FAILURE = 'COMPANY_GET_FAILURE';

// mağza güncelle aksiyonları
export const COMPANY_UPDATE_REQUEST = 'COMPANY_UPDATE_REQUEST';
export const COMPANY_UPDATE_SUCCESS = 'COMPANY_UPDATE_SUCCESS';
export const COMPANY_UPDATE_FAILURE = 'COMPANY_UPDATE_FAILURE';


// Üye ADDRESS delete aksiyonları
export const ADDRESS_DELETE_REQUEST = 'ADDRESS_DELETE_REQUEST';
export const ADDRESS_DELETE_SUCCESS = 'ADDRESS_DELETE_SUCCESS';
export const ADDRESS_DELETE_FAILURE = 'ADDRESS_DELETE_FAILURE';


// parola aksiyonları
export const PASSWORD_REQUEST = 'PASSWORD_REQUEST';
export const PASSWORD_SUCCESS = 'PASSWORD_SUCCESS';
export const PASSWORD_FAILURE = 'PASSWORD_FAILURE';

// Fatura aksiyonları
export const INVOICES_FETCH_REQUEST = 'INVOICES_FETCH_REQUEST';
export const INVOICES_FETCH_SUCCESS = 'INVOICES_FETCH_SUCCESS';
export const INVOICES_FETCH_FAILURE = 'INVOICES_FETCH_FAILURE';

// Fatura ekle aksiyonları
export const INVOICES_ADD_REQUEST = 'INVOICES_ADD_REQUEST';
export const INVOICES_ADD_SUCCESS = 'INVOICES_ADD_SUCCESS';
export const INVOICES_ADD_FAILURE = 'INVOICES_ADD_FAILURE';

// Fatura Güncelle aksiyonları
export const INVOICES_UPDATE_REQUEST = 'INVOICES_UPDATE_REQUEST';
export const INVOICES_UPDATE_SUCCESS = 'INVOICES_UPDATE_SUCCESS';
export const INVOICES_UPDATE_FAILURE = 'INVOICES_UPDATE_FAILURE';

// // Fatura müşterisi ekle aksiyonları
export const INVOICES_CUSTOMER_ADD_REQUEST = 'INVOICES_CUSTOMER_ADD_REQUEST';
export const INVOICES_CUSTOMER_ADD_SUCCESS = 'INVOICES_CUSTOMER_ADD_SUCCESS';
export const INVOICES_CUSTOMER_ADD_FAILURE = 'INVOICES_CUSTOMER_ADD_FAILURE';


// Fatura müşterisi aksiyonları
export const INVOICES_CUSTOMER_FETCH_REQUEST = 'INVOICES_CUSTOMER_FETCH_REQUEST';
export const INVOICES_CUSTOMER_FETCH_SUCCESS = 'INVOICES_CUSTOMER_FETCH_SUCCESS';
export const INVOICES_CUSTOMER_FETCH_FAILURE = 'INVOICES_CUSTOMER_FETCH_FAILURE';


// marketpleaces aksiyonları
export const MARKETPLACES_REQUEST = 'MARKETPLACES_REQUEST';
export const MARKETPLACES_SUCCESS = 'MARKETPLACES_SUCCESS';
export const MARKETPLACES_FAILURE = 'MARKETPLACES_FAILURE';


// marketpleaces add aksiyonları
export const ADD_MARKETPLACES_REQUEST = 'ADD_MARKETPLACES_REQUEST';
export const ADD_MARKETPLACES_SUCCESS = 'ADD_MARKETPLACES_SUCCESS';
export const ADD_MARKETPLACES_FAILURE = 'ADD_MARKETPLACES_FAILURE';

// marketpleacesAccount aksiyonları
export const MARKETPLACES_ACCOUNT_REQUEST = 'MARKETPLACES_ACCOUNT_REQUEST';
export const MARKETPLACES_ACCOUNT_SUCCESS = 'MARKETPLACES_ACCOUNT_SUCCESS';
export const MARKETPLACES_ACCOUNT_FAILURE = 'MARKETPLACES_ACCOUNT_FAILURE';



// marketpleaces update aksiyonları
export const UPDATE_MARKETPLACES_REQUEST = 'UPDATE_MARKETPLACES_REQUEST';
export const UPDATE_MARKETPLACES_SUCCESS = 'UPDATE_MARKETPLACES_SUCCESS';
export const UPDATE_MARKETPLACES_FAILURE = 'UPDATE_MARKETPLACES_FAILURE';




// ÜRÜN ekle aksiyonları
export const PRODUCT_XML_ADD_REQUEST = 'PRODUCT_XML_ADD_REQUEST';
export const PRODUCT_XML_ADD_SUCCESS = 'PRODUCT_XML_ADD_SUCCESS';
export const PRODUCT_XML_ADD_FAILURE = 'PRODUCT_XML_ADD_FAILURE';




// ECOMMARCEPLACES aksiyonları
export const ECOMMARCEPLACES_REQUEST = 'ECOMMARCEPLACES_REQUEST';
export const ECOMMARCEPLACES_SUCCESS = 'ECOMMARCEPLACES_SUCCESS';
export const ECOMMARCEPLACES_FAILURE = 'ECOMMARCEPLACES_FAILURE';


// ECOMMARCEPLACES aksiyonları
export const ECOMMARCEPLACES_ACCOUNT_REQUEST = 'ECOMMARCEPLACES_ACCOUNT_REQUEST';
export const ECOMMARCEPLACES_ACCOUNT_SUCCESS = 'ECOMMARCEPLACES_ACCOUNT_SUCCESS';
export const ECOMMARCEPLACES_ACCOUNT_FAILURE = 'ECOMMARCEPLACES_ACCOUNT_FAILURE';



// ECOMMARCEPLACES update aksiyonları
export const UPDATE_ECOMMARCEPLACES_REQUEST = 'UPDATE_ECOMMARCEPLACES_REQUEST';
export const UPDATE_ECOMMARCEPLACES_SUCCESS = 'UPDATE_ECOMMARCEPLACES_SUCCESS';
export const UPDATE_ECOMMARCEPLACES_FAILURE = 'UPDATE_ECOMMARCEPLACES_FAILURE';



export const BRAND_REQUEST = 'BRAND_REQUEST';
export const BRAND_SUCCESS = 'BRAND_SUCCESS';
export const BRAND_FAILURE = 'BRAND_FAILURE';

export const ADD_BRAND_REQUEST = 'ADD_BRAND_REQUEST';
export const ADD_BRAND_SUCCESS = 'ADD_BRAND_SUCCESS';
export const ADD_BRAND_FAILURE = 'ADD_BRAND_FAILURE';

export const DELETE_BRAND_REQUEST = 'DELETE_BRAND_REQUEST';
export const DELETE_BRAND_SUCCESS = 'DELETE_BRAND_SUCCESS';
export const DELETE_BRAND_FAILURE = 'DELETE_BRAND_FAILURE';


export const UPDATE_BRAND_REQUEST = 'UPDATE_BRAND_REQUEST';
export const UPDATE_BRAND_SUCCESS = 'UPDATE_BRAND_SUCCESS';
export const UPDATE_BRAND_FAILURE = 'UPDATE_BRAND_FAILURE';


// Ürün aksiyonları
export const PRODUCTS_FETCH_REQUEST = 'PRODUCTS_FETCH_REQUEST';
export const PRODUCTS_FETCH_SUCCESS = 'PRODUCTS_FETCH_SUCCESS';
export const PRODUCTS_FETCH_FAILURE = 'PRODUCTS_FETCH_FAILURE';

// Ürün güncelleme aksiyonları (Eğer güncelleme işlemi yapacaksanız)
export const PRODUCT_UPDATE_REQUEST = 'PRODUCT_UPDATE_REQUEST';
export const PRODUCT_UPDATE_SUCCESS = 'PRODUCT_UPDATE_SUCCESS';
export const PRODUCT_UPDATE_FAILURE = 'PRODUCT_UPDATE_FAILURE';

// Ürün ekleme aksiyonları (Eğer ürün ekleme işlemi yapacaksanız)
export const PRODUCT_ADD_REQUEST = 'PRODUCT_ADD_REQUEST';
export const PRODUCT_ADD_SUCCESS = 'PRODUCT_ADD_SUCCESS';
export const PRODUCT_ADD_FAILURE = 'PRODUCT_ADD_FAILURE';

// Ürün silme aksiyonları (Eğer ürün silme işlemi yapacaksanız)
export const PRODUCT_DELETE_REQUEST = 'PRODUCT_DELETE_REQUEST';
export const PRODUCT_DELETE_SUCCESS = 'PRODUCT_DELETE_SUCCESS';
export const PRODUCT_DELETE_FAILURE = 'PRODUCT_DELETE_FAILURE';



//Kategori Ağacı aksiyonları
export const CATEGORYS_UPDATE_FAILURE = 'CATEGORYTS_UPDATE_FAILURE';
export const CATEGORYS_UPDATE_REQUEST = 'CATEGORYTS_UPDATE_REQUEST';
export const CATEGORYS_UPDATE_SUCCESS = 'CATEGORYTS_UPDATE_SUCCESS';

export const CATEGORYS_REQUEST = 'CATEGORYS_REQUEST';
export const CATEGORYS_SUCCESS = 'CATEGORYS_SUCCESS';
export const CATEGORYS_FAILURE = 'CATEGORYS_FAILURE';

export const ADD_CATEGORYS_REQUEST = 'ADD_CATEGORYS_REQUEST';
export const ADD_CATEGORYS_SUCCESS = 'ADD_CATEGORYS_SUCCESS';
export const ADD_CATEGORYS_FAILURE = 'ADD_CATEGORYS_FAILURE';

export const DELETE_CATEGORYS_REQUEST = 'DELETE_CATEGORYS_REQUEST';
export const DELETE_CATEGORYS_SUCCESS = 'DELETE_CATEGORYS_SUCCESS';
export const DELETE_CATEGORYS_FAILURE = 'DELETE_CATEGORYS_FAILURE';

export const DELETE_CATEGORYSWİTHSUBCATEGORİES_REQUEST = 'DELETE_CATEGORYSWİTHSUBCATEGORİES_REQUEST';
export const DELETE_CATEGORYSWİTHSUBCATEGORİES_SUCCESS = 'DELETE_CATEGORYSWİTHSUBCATEGORİES_SUCCESS';
export const DELETE_CATEGORYSWİTHSUBCATEGORİES_FAILURE = 'DELETE_CATEGORYSWİTHSUBCATEGORİES_FAILURE';

export const PRODUCT_EXCEL_ADD_REQUEST = 'PRODUCT_EXCEL_ADD_REQUEST';
export const PRODUCT_EXCEL_ADD_SUCCESS = 'PRODUCT_EXCEL_ADD_SUCCESS';
export const PRODUCT_EXCEL_ADD_FAILURE = 'PRODUCT_EXCEL_ADD_FAILURE';

export const PRODUCT_EXCEL_GET_REQUEST = 'PRODUCT_EXCEL_GET_REQUEST';
export const PRODUCT_EXCEL_GET_SUCCESS = 'PRODUCT_EXCEL_GET_SUCCESS';
export const PRODUCT_EXCEL_GET_FAILURE = 'PRODUCT_EXCEL_GET_FAILURE';

// xml  aksiyonları
export const XML_ADD_REQUEST = 'XML_ADD_REQUEST';
export const XML_ADD_SUCCESS = 'XML_ADD_SUCCESS';
export const XML_ADD_FAILURE = 'XML_ADD_FAILURE';


export const XML_GET_REQUEST = 'XML_GET_REQUEST';
export const XML_GET_SUCCESS = 'XML_GET_SUCCESS';
export const XML_GET_FAILURE = 'XML_GET_FAILURE';


export const PROVIDER_GET_REQUEST = 'PROVIDER_GET_REQUEST';
export const PROVIDER_GET_SUCCESS = 'PROVIDER_GET_SUCCESS';
export const PROVIDER_GET_FAILURE = 'PROVIDER_GET_FAILURE';

export const PRODUCT_FILTER_UPDATE_REQUEST = "PRODUCT_FILTER_UPDATE_REQUEST";
export const PRODUCT_FILTER_UPDATE_SUCCESS = "PRODUCT_FILTER_UPDATE_SUCCESS";
export const PRODUCT_FILTER_UPDATE_FAILURE = "PRODUCT_FILTER_UPDATE_FAILURE";



export const CATEGORY_VARIANT_REQUEST = 'CATEGORY_VARIANT_REQUEST';
export const CATEGORY_VARIANT_SUCCESS = 'CATEGORY_VARIANT_SUCCESS';
export const CATEGORY_VARIANT_FAILURE = 'CATEGORY_VARIANT_FAILURE';

export const ADD_CATEGORY_VARIANT_REQUEST = 'ADD_CATEGORY_VARIANT_REQUEST';
export const ADD_CATEGORY_VARIANT_SUCCESS = 'ADD_CATEGORY_VARIANT_SUCCESS';
export const ADD_CATEGORY_VARIANT_FAILURE = 'ADD_CATEGORY_VARIANT_FAILURE';

export const DELETE_CATEGORY_VARIANT_REQUEST = 'DELETE_CATEGORY_VARIANT_REQUEST';
export const DELETE_CATEGORY_VARIANT_SUCCESS = 'DELETE_CATEGORY_VARIANT_SUCCESS';
export const DELETE_CATEGORY_VARIANT_FAILURE = 'DELETE_CATEGORY_VARIANT_FAILURE';


export const ATTRIBUTE_GET_REQUEST = 'ATTRIBUTE_GET_REQUEST';
export const ATTRIBUTE_GET_SUCCESS = 'ATTRIBUTE_GET_SUCCESS';
export const ATTRIBUTE_GET_FAILURE = 'ATTRIBUTE_GET_FAILURE';

export const PLACES_CATEGORY_GET_REQUEST = "PLACES_CATEGORY_GET_REQUEST";
export const PLACES_CATEGORY_GET_SUCCESS = "PLACES_CATEGORY_GET_SUCCESS";
export const PLACES_CATEGORY_GET_FAILURE = "PLACES_CATEGORY_GET_FAILURE";

export const PLACES_CATEGORY_ADD_REQUEST = "PLACES_CATEGORY_ADD_REQUEST";
export const PLACES_CATEGORY_ADD_SUCCESS = "PLACES_CATEGORY_ADD_SUCCESS";
export const PLACES_CATEGORY_ADD_FAILURE = "PLACES_CATEGORY_ADD_FAILURE";

export const OUTWARD_GET_CATEGORY_REQUEST = 'OUTWARD_GET_CATEGORY_REQUEST';
export const OUTWARD_GET_CATEGORY_SUCCESS = 'OUTWARD_GET_CATEGORY_SUCCESS';
export const OUTWARD_GET_CATEGORY_FAILURE = 'OUTWARD_GET_CATEGORY_FAILURE';


export const OUTWARD_GET_CATEGORY_ATTRIBUTE_REQUEST = 'OUTWARD_GET_CATEGORY_ATTRIBUTE_REQUEST';
export const OUTWARD_GET_CATEGORY_ATTRIBUTE_SUCCESS = 'OUTWARD_GET_CATEGORY_ATTRIBUTE_SUCCESS';
export const OUTWARD_GET_CATEGORY_ATTRIBUTE_FAILURE = 'OUTWARD_GET_CATEGORY_ATTRIBUTE_FAILURE'; 

export const PLACES_CATEGORY_DELETE_REQUEST = "PLACES_CATEGORY_DELETE_REQUEST";
export const PLACES_CATEGORY_DELETE_SUCCESS = "PLACES_CATEGORY_DELETE_SUCCESS";
export const PLACES_CATEGORY_DELETE_FAILURE = "PLACES_CATEGORY_DELETE_FAILURE";

export const OUTWARD_DELETE_CATEGORY_ATTRIBUTE_REQUEST = 'OUTWARD_DELETE_CATEGORY_ATTRIBUTE_REQUEST';
export const OUTWARD_DELETE_CATEGORY_ATTRIBUTE_SUCCESS = 'OUTWARD_DELETE_CATEGORY_ATTRIBUTE_SUCCESS';
export const OUTWARD_DELETE_CATEGORY_ATTRIBUTE_FAILURE = 'OUTWARD_DELETE_CATEGORY_ATTRIBUTE_FAILURE'; 

export const OUTWARD_BRAND_REQUEST = 'OUTWARD_BRAND_REQUEST';
export const OUTWARD_BRAND_SUCCESS = 'OUTWARD_BRAND_SUCCESS';
export const OUTWARD_BRAND_FAILURE = 'OUTWARD_BRAND_FAILURE';



export const MARKETPLACESBRAND_ADD_REQUEST = 'MARKETPLACESBRAND_ADD_REQUEST';
export const MARKETPLACESBRAND_ADD_SUCCESS = 'MARKETPLACESBRAND_ADD_SUCCESS';
export const MARKETPLACESBRAND_ADD_FAILURE = 'MARKETPLACESBRAND_ADD_FAILURE';


export const MARKETPLACESBRAND_GET_REQUEST = 'MARKETPLACESBRAND_GET_REQUEST';
export const MARKETPLACESBRAND_GET_SUCCESS = 'MARKETPLACESBRAND_GET_SUCCESS';
export const MARKETPLACESBRAND_GET_FAILURE = 'MARKETPLACESBRAND_GET_FAILURE';


export const MARKETPLACESBRAND_DELETE_REQUEST = 'MARKETPLACESBRAND_DELETE_REQUEST';
export const MARKETPLACESBRAND_DELETE_SUCCESS = 'MARKETPLACESBRAND_DELETE_SUCCESS';
export const MARKETPLACESBRAND_DELETE_FAILURE = 'MARKETPLACESBRAND_DELETE_FAILURE';




export const BULK_ADD_REQUEST = 'BULK_ADD_REQUEST';
export const BULK_ADD_SUCCESS = 'BULK_ADD_SUCCESS';
export const BULK_ADD_FAILURE = 'BULK_ADD_FAILURE';


export const BULK_GET_REQUEST = 'BULK_GET_REQUEST';
export const BULK_GET_SUCCESS = 'BULK_GET_SUCCESS';
export const BULK_GET_FAILURE = 'BULK_GET_FAILURE';

// BULK TEXT TRANSACTION aksiyonları
export const BULK_TEXT_ADD_REQUEST = 'BULK_TEXT_ADD_REQUEST';
export const BULK_TEXT_ADD_SUCCESS = 'BULK_TEXT_ADD_SUCCESS';
export const BULK_TEXT_ADD_FAILURE = 'BULK_TEXT_ADD_FAILURE';

export const BULK_TEXT_GET_REQUEST = 'BULK_TEXT_GET_REQUEST';
export const BULK_TEXT_GET_SUCCESS = 'BULK_TEXT_GET_SUCCESS';
export const BULK_TEXT_GET_FAILURE = 'BULK_TEXT_GET_FAILURE';



// INVOICEINTEGRATOR aksiyonları
export const INVOICEINTEGRATOR_REQUEST = 'INVOICEINTEGRATOR_REQUEST';
export const INVOICEINTEGRATOR_SUCCESS = 'INVOICEINTEGRATOR_SUCCESS';
export const INVOICEINTEGRATOR_FAILURE = 'INVOICEINTEGRATOR_FAILURE';


// INVOICEINTEGRATOR aksiyonları
export const INVOICEINTEGRATOR_ACCOUNT_REQUEST = 'INVOICEINTEGRATOR_ACCOUNT_REQUEST';
export const INVOICEINTEGRATOR_ACCOUNT_SUCCESS = 'INVOICEINTEGRATOR_ACCOUNT_SUCCESS';
export const INVOICEINTEGRATOR_ACCOUNT_FAILURE = 'INVOICEINTEGRATOR_ACCOUNT_FAILURE';



// INVOICEINTEGRATOR update aksiyonları
export const UPDATE_INVOICEINTEGRATOR_REQUEST = 'UPDATE_INVOICEINTEGRATOR_REQUEST';
export const UPDATE_INVOICEINTEGRATOR_SUCCESS = 'UPDATE_INVOICEINTEGRATOR_SUCCESS';
export const UPDATE_INVOICEINTEGRATOR_FAILURE = 'UPDATE_INVOICEINTEGRATOR_FAILURE';

// Store seçim aksiyonu
export const STORE_SELECTED = 'STORE_SELECTED';

// Sipariş yazdırma şablonu ayarları aksiyonları
export const PRINT_TEMPLATE_SETTING_ADD_REQUEST = 'PRINT_TEMPLATE_SETTING_ADD_REQUEST';
export const PRINT_TEMPLATE_SETTING_ADD_SUCCESS = 'PRINT_TEMPLATE_SETTING_ADD_SUCCESS';
export const PRINT_TEMPLATE_SETTING_ADD_FAILURE = 'PRINT_TEMPLATE_SETTING_ADD_FAILURE';

export const PRINT_TEMPLATE_SETTING_GET_REQUEST = 'PRINT_TEMPLATE_SETTING_GET_REQUEST';
export const PRINT_TEMPLATE_SETTING_GET_SUCCESS = 'PRINT_TEMPLATE_SETTING_GET_SUCCESS';
export const PRINT_TEMPLATE_SETTING_GET_FAILURE = 'PRINT_TEMPLATE_SETTING_GET_FAILURE';

export const PRINT_TEMPLATE_SETTING_UPDATE_REQUEST = 'PRINT_TEMPLATE_SETTING_UPDATE_REQUEST';
export const PRINT_TEMPLATE_SETTING_UPDATE_SUCCESS = 'PRINT_TEMPLATE_SETTING_UPDATE_SUCCESS';
export const PRINT_TEMPLATE_SETTING_UPDATE_FAILURE = 'PRINT_TEMPLATE_SETTING_UPDATE_FAILURE';

// Pazaryeri ürün senkronizasyon tetikleyicisi aksiyonları
export const PLACE_PRODUCT_TRIGGER_GET_REQUEST = 'PLACE_PRODUCT_TRIGGER_GET_REQUEST';
export const PLACE_PRODUCT_TRIGGER_GET_SUCCESS = 'PLACE_PRODUCT_TRIGGER_GET_SUCCESS';
export const PLACE_PRODUCT_TRIGGER_GET_FAILURE = 'PLACE_PRODUCT_TRIGGER_GET_FAILURE';

export const PLACE_PRODUCT_TRIGGER_ADD_REQUEST = 'PLACE_PRODUCT_TRIGGER_ADD_REQUEST';
export const PLACE_PRODUCT_TRIGGER_ADD_SUCCESS = 'PLACE_PRODUCT_TRIGGER_ADD_SUCCESS';
export const PLACE_PRODUCT_TRIGGER_ADD_FAILURE = 'PLACE_PRODUCT_TRIGGER_ADD_FAILURE';

export const PLACE_PRODUCT_TRIGGER_UPDATE_REQUEST = 'PLACE_PRODUCT_TRIGGER_UPDATE_REQUEST';
export const PLACE_PRODUCT_TRIGGER_UPDATE_SUCCESS = 'PLACE_PRODUCT_TRIGGER_UPDATE_SUCCESS';
export const PLACE_PRODUCT_TRIGGER_UPDATE_FAILURE = 'PLACE_PRODUCT_TRIGGER_UPDATE_FAILURE';

export const PLACE_TRIGGER_DEFINATION_GET_REQUEST = 'PLACE_TRIGGER_DEFINATION_GET_REQUEST';
export const PLACE_TRIGGER_DEFINATION_GET_SUCCESS = 'PLACE_TRIGGER_DEFINATION_GET_SUCCESS';
export const PLACE_TRIGGER_DEFINATION_GET_FAILURE = 'PLACE_TRIGGER_DEFINATION_GET_FAILURE';

export const PLACE_TRIGGER_DEFINATION_ADD_REQUEST = 'PLACE_TRIGGER_DEFINATION_ADD_REQUEST';
export const PLACE_TRIGGER_DEFINATION_ADD_SUCCESS = 'PLACE_TRIGGER_DEFINATION_ADD_SUCCESS';
export const PLACE_TRIGGER_DEFINATION_ADD_FAILURE = 'PLACE_TRIGGER_DEFINATION_ADD_FAILURE';

export const PLACE_TRIGGER_DEFINATION_DELETE_REQUEST = 'PLACE_TRIGGER_DEFINATION_DELETE_REQUEST';
export const PLACE_TRIGGER_DEFINATION_DELETE_SUCCESS = 'PLACE_TRIGGER_DEFINATION_DELETE_SUCCESS';
export const PLACE_TRIGGER_DEFINATION_DELETE_FAILURE = 'PLACE_TRIGGER_DEFINATION_DELETE_FAILURE';

export const PLACE_PRODUCT_DEFINATION_RULE_GET_REQUEST = 'PLACE_PRODUCT_DEFINATION_RULE_GET_REQUEST';
export const PLACE_PRODUCT_DEFINATION_RULE_GET_SUCCESS = 'PLACE_PRODUCT_DEFINATION_RULE_GET_SUCCESS';
export const PLACE_PRODUCT_DEFINATION_RULE_GET_FAILURE = 'PLACE_PRODUCT_DEFINATION_RULE_GET_FAILURE';

export const PLACE_PRODUCT_DEFINATION_RULE_ADD_REQUEST = 'PLACE_PRODUCT_DEFINATION_RULE_ADD_REQUEST';
export const PLACE_PRODUCT_DEFINATION_RULE_ADD_SUCCESS = 'PLACE_PRODUCT_DEFINATION_RULE_ADD_SUCCESS';
export const PLACE_PRODUCT_DEFINATION_RULE_ADD_FAILURE = 'PLACE_PRODUCT_DEFINATION_RULE_ADD_FAILURE';

export const PLACE_PRODUCT_DEFINATION_RULE_UPDATE_REQUEST = 'PLACE_PRODUCT_DEFINATION_RULE_UPDATE_REQUEST';
export const PLACE_PRODUCT_DEFINATION_RULE_UPDATE_SUCCESS = 'PLACE_PRODUCT_DEFINATION_RULE_UPDATE_SUCCESS';
export const PLACE_PRODUCT_DEFINATION_RULE_UPDATE_FAILURE = 'PLACE_PRODUCT_DEFINATION_RULE_UPDATE_FAILURE';

export const PLACE_PRODUCT_TRIGGER_LOG_GET_REQUEST = 'PLACE_PRODUCT_TRIGGER_LOG_GET_REQUEST';
export const PLACE_PRODUCT_TRIGGER_LOG_GET_SUCCESS = 'PLACE_PRODUCT_TRIGGER_LOG_GET_SUCCESS';
export const PLACE_PRODUCT_TRIGGER_LOG_GET_FAILURE = 'PLACE_PRODUCT_TRIGGER_LOG_GET_FAILURE';